import moment from "moment"
import { useEffect, useState } from "react"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import { useLocation } from "react-router-dom"
import Send from "../../core/communication"
import { setData } from "../../core/redux/app/Actions"
import { useDWOptions } from "../../core/utils/hooks/useDwOptions"
import ClusteredPathTopicsScreen from "../../screen/ClusteredPathTopicsScreen"
import { useScope } from "../SelectProjectCompanyContainer"

export const getIds = (data) => {
  return data
    .map((item) => item)
    .map((item) => `'${item}'`)
    .join(",")
}

const ClusteredPathTopicsContainer = () => {
  const location = useLocation()
  const { state } = location
  const { scope, scopeType } = useScope()
  const dispatch = useDispatch()
  const clusteredPathTopicsSaved = useSelector((state) => state.app.clusteredPathTopicsSaved)
  const [dw, reload] = useDWOptions()
  const [selectedData, setSelectedData] = useState([])
  const [dataToChart, setDataToChart] = useState(clusteredPathTopicsSaved || [])
  const [loading, setLoading] = useState(false)

  const loadDwData = async () => {
    let extraProps = ""

    const getFormsId = [...new Set(state.charts?.map((item) => item.formId))]
    const getQuestions = [...new Set(state?.charts?.map((item) => item.question.split(":")[1]))]

    if (getQuestions.length > 0) {
      extraProps += `&questions=${getIds(getQuestions)}`
    }

    if (getFormsId.length > 0) {
      extraProps += `&forms=${getIds(getFormsId)}`
    }

    try {
      setLoading(true)
      const dw = await Send.get("/dw/data/content", `projects='${scope?.id}'${extraProps}&scopeType=${scopeType}`);
      setLoading(false)
      setSelectedData(dw)
    } catch (error) {
      console.log(error)
    }
  }

  const transformData = () => {
    let additionalData2 = selectedData.map((item) => ({
      Etapa: item.Etapa,
      Etapa_Pergunta: item.Pergunta,
      Pergunta_codigo: item?.Pergunta_codigo,
      Pergunta_codigo_1: item?.Pergunta_codigo,
      Pergunta: item.Pergunta,
      Resposta: item.Resposta === "Ø" ? "Sem Resposta" : item.Resposta,
      Produtor: item.Produtor,
      ProdutorId: item.ProdutorId,
      Formulario: dw?.forms && dw.forms.find((row) => row.value === item.Formulario),
      Projeto: item.Projeto,
      Tecnico: item.Tecnico,
      realInicio: item.Inicio,
      Inicio: moment(item.Inicio).format("DD/MM/YYYY"),
      ID: item.ID,
      Tipo_Pergunta: item.Tipo_Pergunta,
      [item.Pergunta_codigo_1]: item.Resposta,
      value: item.Pergunta_codigo_1,
      question: item.Pergunta?.replace(":", " - "),
      inFilter: true,
    }))

    const array = additionalData2.map((item, index) => {
      return {
        id: item.ID,
        step: item.Etapa,
        title: item.Etapa,
        question: item.question,
        components: [
          {
            codes: [
              {
                title: "Resposta",
                code: item.Pergunta_codigo_1,
              },
              {
                title: "Técnico",
                code: "Tecnico",
              },
            ],
            [item.Pergunta_codigo]: item.Resposta,
            stackedBy: "Produtor",
            fields: [item],
            columns: ["Tecnico", item.Pergunta_codigo_1],
            standardDeviation: {
              title: "",
              code: "",
              info: [],
            },
            type: "",
            question: item.question || "",
            value: item.Pergunta_codigo,
          },
        ],
      }
    })

    setDataToChart(Object.values(array.reduce((acc,cur)=>Object.assign(acc,{[cur.id]:cur}),{})))

    dispatch(
      setData({
        clusteredPathTopicsSaved: array,
      }),
    )
  }

  useEffect(() => {
    loadDwData()
  }, [state])

  useEffect(() => {
    transformData()
  }, [selectedData])

  const checkExistsClusteredPathTopics = () => {
    const check = dataToChart?.filter((clust) =>
      clusteredPathTopicsSaved.every((item) => item.id === clust.id),
    )

    if (check?.length > 0) {
      return dataToChart
    } else {
      return clusteredPathTopicsSaved
    }
  }

  return (
    <ClusteredPathTopicsScreen {...{ dataToChart: checkExistsClusteredPathTopics(), loading }} />
  )
}

export default ClusteredPathTopicsContainer